<template>
  <div>
    <div>
      <div class="bidContent">
        <div>
          <van-collapse v-model="activeNames" :border="false">
            <van-collapse-item name="1">
              <template slot="title">
                <div style="position: relative;">
                  <img
                    src="../assets/images/flow.png"
                    alt=""
                    style="width:60px; height:60px; color: #6c9fde; margin-left: 5px;"
                  />
                  <span style="margin-left: 36px; position: absolute; top:6px; font-weight: 700; font-size:16px; font-family: 微软雅黑;color:#646566;">操作指南</span>
                  <span style="margin-left: 36px; position: absolute; top:30px;  font-size:14px; font-family: 微软雅黑;color:#606060;">点击查看流程</span>
                </div>
              </template>
              <div class="flow">
                <div class="flow-serial">1</div>
                <div style="flex: 1">
                  <h4>查看详情</h4>
                  <p>点击货车ETC中的查看详情可以看到申办银行对应的车牌</p>
                </div>
              </div>
              <div class="flow">
                <div class="flow-serial">2</div>
                <div style="flex: 1">
                  <h4>充值</h4>
                  <p>客户通行前，选择ETC充值，输入金额确认充值之后自动跳转页面</p>
                </div>
              </div>
              <div class="flow">
                <div class="flow-serial">3</div>
                  <div style="flex: 1">
                    <h4>账单查询</h4>
                    <p>可以查询通行费用，点击账单可查询对应通行明细</p>
                  </div>
              </div>
              <div class="flow">
                <div class="flow-serial">4</div>
                  <div style="flex: 1">
                    <h4>余额查询</h4>
                    <p>点击余额明细，卡内余额为当前结算户总额，包含冻结金额及可用余额</p>
                  </div>
              </div>
         
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ["1"]
    };
  }
};
</script>

<style>
.bidContent {
  margin-top: 20px;
  width: 100%;
  padding: 4px 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 2px 2px 2px 1px #c3c3c3;
}
 .flow {
  display: flex;
  margin-left: 18px;
}
.flow h4 {
  color: #606060;
}
.flow h4, p {
  height: 10px;
  padding: 0 10px;
}
.flow-serial {
  align-items: center;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin-top: 20px;
  border-radius: 15px 15px;
  border: 1px solid #a6d1ff;
  margin-right: 10px;
} 

</style>



// WEBPACK FOOTER //
// src/components/BidFlow.vue